import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { TagViewModel } from './../../models/view-models/tag-models/tag-view.model';
import { PlaylistDTO } from '../../models/view-models/playlist-models/playlist-dto.model';
import { LibraryEditItemTypeEnum } from '../../enums/library-edit-item-type.enum';
import { BehaviorScreen } from '../../models/view-models/monitor-models/screen.type';
import { DropItem } from '../../interfaces/drop-item.model';
import { DropItemViewModel } from '../../interfaces/drop-item-data.view-model';
import { ShareContentInfo } from '../../interfaces/share-content-info.interface';

@Injectable()
export class UIService {
  isGreyoutVisible = false;
  isLeftSidePanelVisible = true;
  isRightSidePanelVisible = true;
  isTagsPanelExpanded = false;
  isPlaylistPanelExpanded = true;
  isSchedulePanelExpanded = false;
  isRightPlaylistPanelExpanded = false;

  bottomPanelPinnedSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  bottomPanelVisibleSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  dragActivationSubject: BehaviorSubject<boolean> = new BehaviorSubject(null);
  itemlistDragSubject: BehaviorSubject<DropItem> = new BehaviorSubject<DropItem>(null);
  itemlistDropSubject: Subject<DropItemViewModel> = new Subject<DropItemViewModel>();
  displayConfigToolIsToShowBackgroundChanged: Subject<boolean> = new Subject();
  isBottomPanelButtonHidden: boolean = false;
  ADBDeviceSelectionChanged: Subject<void> = new Subject();
  selectedAllCheckboxesSubject: Subject<boolean> = new Subject();
  selectedPhysicalAddress: string;
  libraryEditItem$: BehaviorSubject<{
    item: PlaylistDTO | TagViewModel;
    type: LibraryEditItemTypeEnum;
  }> = new BehaviorSubject(null);
  unselectAllPlaylistItems = new Subject<void>();
  selectionInProgress = new BehaviorSubject<boolean>(false);
  shareContentLink = signal<ShareContentInfo | null>(null);

  handleItemlistDrag(dragData: DropItem) {
    this.itemlistDragSubject.next(dragData);
  }

  handleDragActivation(isActive: boolean) {
    this.dragActivationSubject.next(isActive);
  }

  showLibraryEditPanel(
    item: PlaylistDTO | TagViewModel,
    type: LibraryEditItemTypeEnum
  ): void {
    if (item) {
      this.libraryEditItem$.next({ item, type });
    }
  }

  hideLibraryEditPanel() {
    this.libraryEditItem$.next(null);
  }

  showGreyout() {
    this.isGreyoutVisible = true;
  }

  hideGreyout() {
    this.isGreyoutVisible = false;
  }

  showBottomPanel() {
    this.bottomPanelVisibleSubject.next(true);
  }

  hideBottomPanel() {
    if (!this.bottomPanelPinnedSubject.value) {
      this.bottomPanelVisibleSubject.next(false);
    }
  }

  pinBottomPanel() {
    this.bottomPanelPinnedSubject.next(true);
  }

  unpinBottomPanel() {
    this.bottomPanelPinnedSubject.next(false);
  }

  showLeftSidePanel() {
    this.isLeftSidePanelVisible = true;
  }

  showRightSidePanel() {
    this.isRightSidePanelVisible = true;
  }

  hideLeftSidePanel() {
    this.isLeftSidePanelVisible = false;
  }

  hideRightSidePanel() {
    this.isRightSidePanelVisible = false;
  }

  handleItemlistDrop(itemlist: DropItem, monitor: BehaviorScreen): void {
    const target = {
      Itemlist: itemlist,
      Monitor: monitor,
    };
    this.itemlistDropSubject.next(target);
  }
}
